import qs from 'qs';
import axios from "axios";
import store from '../store';
export default function (config) {
    const instance = axios.create({
        // withCredentials: true,
        // crossDomain: true,
        baseURL: window.location.href.includes('localhost')?' https://mock.mengxuegu.com/mock/639930012e0f396e51a5c707/api':'https://actblood.web.sdo.com',
        // baseURL:'https://actblood.web.sdo.com',
        timeout: 5000
    })
    instance.interceptors.request.use(config => {
        if(!config.skipLoading){
            store.commit('SETLOADING', true);
        }
        // POST处理
        if (config.method.toLowerCase() == "post") {
            config.data = qs.stringify(config.data);
        }
        return config;
    }, err => {
        CsLib.alert('网络不好，请稍后重试！', 'error');
    })
    instance.interceptors.response.use(res => {
        store.commit('SETLOADING', false);
        if(res.data.success){
            return res.data.msg;
        }else{
            // 是否显示错误信息
            if(config.skipError){
                return false
            }
            // 登录
            if(res.data.msg=="-992"){
                store.commit('LOGINSHOW');
                return false;
            }
            // 角色信息有误
            if(res.data.msg=="-991"){
                return "-991"
            }
            return CsLib.alert(res.data.msg,'error');
        }
    }, err => {
        CsLib.alert('网络不好，请稍后重试！', 'error');
    })
    return instance(config);
}